const UPSELL_WRAPPER_SELECTOR = '[data-pdp-upsells]';
const UPSELL_LIST_SELECTOR = '[data-pdp-upsells-list]';
const SECTION_ID = 'cart-drawer-upsells';
const DEFAULT_MAX = 4;

const getStoreRoot = () => window.Shopify?.routes?.root || '/';

const getStoreUrl = (path = '') => new URL(path, window.location.origin + getStoreRoot()).toString();

const fetchUpsellCards = async (productId, limit) => {
  const url = getStoreUrl(
    `recommendations/products?section_id=${SECTION_ID}&product_id=${productId}&intent=complementary&limit=${limit}`
  );

  const response = await fetch(url, { headers: { Accept: 'text/html' } });
  if (!response.ok) return [];

  const html = await response.text();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  return [...parsed.querySelectorAll('[data-cart-upsell-card]')];
};

const renderPdpUpsells = async () => {
  const wrapper = document.querySelector(UPSELL_WRAPPER_SELECTOR);
  const list = wrapper?.querySelector(UPSELL_LIST_SELECTOR);
  if (!(wrapper instanceof HTMLElement) || !(list instanceof HTMLElement)) return;

  const productId = wrapper.dataset.productId;
  if (!productId) return;

  const max = parseInt(wrapper.dataset.upsellMax, 10) || DEFAULT_MAX;

  try {
    const cards = (await fetchUpsellCards(productId, max))
      .filter((card) => card.dataset.upsellProductId !== productId)
      .slice(0, max);

    list.replaceChildren(...cards);
    wrapper.hidden = cards.length === 0;
  } catch (error) {
    wrapper.hidden = true;
    list.replaceChildren();
    console.error(error);
  }
};

document.addEventListener('cart:updated', () => void renderPdpUpsells());

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => void renderPdpUpsells());
} else {
  void renderPdpUpsells();
}
